

















































































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import Pagination from './pagination.vue'
import Virtualize from '@/components/virtualize/virtualize.vue'
import _ from 'lodash'
import UiNotFound from '@/components/ui/ui-not-found.vue';
import scrollbarWidth from '@/components/helpers/scrollbar-width'
import LoadingCircle from '@/components/loading-circle.vue';

@Component({
  components: {
    LoadingCircle,
    UiNotFound,
    Pagination,
    Virtualize,
  }
})

export default class UiTable extends Vue {
  scrollbarWidth = scrollbarWidth;
  resize_ob:any;
  tableBodyRefInterval;
  isScrollVisible:boolean = false;
  
  @Prop({ default: [] })
  headers: [];

  @Prop({ default: true })
  useSearch: boolean;

  @Prop({ default: [] })
  items: [];

  @Prop({ default: false })
  loading: boolean;

  @Prop({default: 'auto'})
  tableBodyOverflow: string;

  @Prop()
  sortBy: string;

  @Prop({ default: 5 })
  rowsPerPageCount: number | 'all';

  @Watch('rowsPerPageCount')
  onRowsPerPageCount(value) {
    this.$emit('update:rows-per-page-count', value);
  }

  @Prop({ default: 'name' })
  searchBy: string;

  @Prop({ default: 500 })
  maxHeight: number;

  @Prop({ default: true })
  showPagination: boolean;

  page: number = 1

  search: string = '';

  sortDir: 'asc' | 'desc' = 'asc';

  @Watch('search')
  onSortChange() {
    if (this.page !== 1) {
      this.page = 1
    }
  }

  mounted(){
    this.resize_ob = new (window as any).ResizeObserver((entries)=> {
      const {scrollHeight, clientHeight} = this.$refs?.tableBody as any
      this.isScrollVisible = scrollHeight > clientHeight;


      // since we are observing only a single element, so we access the first element in entries array
      // let rect = entries[0].contentRect;
      // current width & height
      // let width = rect.width;
      // let height = rect.height;
      // console.log('Current Width : ' + width);
      // console.log('Current Height : ' + height);
    });

    this.tableBodyRefInterval = setInterval(() => {
      if (this.$refs.tableBody) {
        this.resize_ob.observe(this.$refs.tableBody);
        clearInterval(this.tableBodyRefInterval)
      }
    }, 50)
  }

  beforeDestroy() {
    if(this.$refs.tableBody){
      this.resize_ob?.unobserve(this.$refs.tableBody);
    }
    clearInterval(this.tableBodyRefInterval)
  }

  get isTableBodyScrollVisible(){
    return this.scrollbarWidth && this.isScrollVisible
  }

  onChangeSort({ sortable,value }) {
    if(!sortable) return;
    if (this.sortBy === value) {
      this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc'
    } else {
      this.sortBy = value;
      this.sortDir = 'asc';
    }
  }

  get tableHeaders() {
    return this.headers
  }

  get tableItemsWithSearch() {
    if(!this.search){
      return this.sortedItems
    }
    return this.sortedItems.filter((item) => (item[this.searchBy] as string).startsWith(this.search))
  }

  get separatedItems() {
    return _.chunk(this.tableItems, 40);
  }
  get tableItems() {
    return this.clientPagination
  }

  get sortedItems() {
    if(!this.sortBy){
      return this.items
    }
    return _.orderBy(this.items, this.sortBy,  this.sortDir)
  }

  get clientPagination() {
    if (this.rowsPerPageCount === 'all' || !this.showPagination) {
      return this.tableItemsWithSearch
    }

    const start = (this.page - 1) * (this.rowsPerPageCount as number)
    const end = this.page * (this.rowsPerPageCount as number)
    return this.tableItemsWithSearch.slice(start, end)
  }

}
